import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import NumberUtils from '../../utils/NumberUtils';
import ManagePayeeCard from './ManagePayeeCard';
import MoveMoneyStore from '../../stores/MoveMoneyStore';
import MoveMoneyPayeeStore from '../../stores/MoveMoneyPayeeStore';
import MoveMoneyPayeeActionCreator from '../../actions/MoveMoneyPayeeActionCreator';
import PatternLibModalComponent from '../common/modals/PatternLibModalComponent';
import ViewPayeePage from './ViewPayeePage';
import ManagePaymentActionCreator from '../../actions/ManagePaymentActionCreator';
import InternetBankingActions from '../../actions/InternetBankingActions';
import MoveMoneyActionCreator from '../../actions/MoveMoneyActionCreator';
import LoaderComponent from '../common/LoaderComponent';
import { sayLandingMessage } from '../../actions/AccessibilityActionCreator';
import AnalyticsUtil from '../../utils/AnalyticsUtil';
import config from '../../config/index';
import SvgIcon from '../common/SvgIcon';
import NonBCustomerError from '../common/NonBCustomerError';
import AccountsStore from '../../stores/AccountsStore';
import UserManagementStore from '../../stores/UserManagementStore';
import AddPayeeOrCompanyMainPage from './AddPayeeOrCompanyMainPage';
import StepHeader from '../../includes/StepHeader';
import StringConstant from '../../constants/StringConstants';
import ManagePaymentsStore from '../../stores/ManagePaymentsStore';
import Panel from '../../components/help/Panel';
import { BioCatchContext } from '../BioCatchContext';
import { MANAGE_PAYEE_CONTEXT } from '../../config/BioCatch';

let isSearching = false;
let isNominatedUser = false;

class ManagePayeePage extends Component {
  constructor(props) {
    super(props);
    this.deletePayee = this.deletePayee.bind(this);
    this.payeeNumber = this.payeeNumber.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.deleteClick = this.deleteClick.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.moveCaretAtEnd = this.moveCaretAtEnd.bind(this);
    this.onInputSearchChange = this.onInputSearchChange.bind(this);
    this.clearclick = this.clearclick.bind(this);
    this.cancelTransactionSearch = this.cancelTransactionSearch.bind(this);
    this.showViewPayeePage = this.showViewPayeePage.bind(this);
    this.renderManagePayee = this.renderManagePayee.bind(this);
    this.goToMoveMoneyPage = this.goToMoveMoneyPage.bind(this);
    this.showManagePayeePage = this.showManagePayeePage.bind(this);
    this.renderPayeeViewPage = this.renderPayeeViewPage.bind(this);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.deleteFromView = this.deleteFromView.bind(this);
    this.edit = this.edit.bind(this);
    this.crossClick = this.crossClick.bind(this);
    this.goToManagePayee = this.goToManagePayee.bind(this);
    this.navigateToManagePayments = this.navigateToManagePayments.bind(this);
    this.retryServices = this.retryServices.bind(this);
    this.showAddPayeePage = this.showAddPayeePage.bind(this);
    this.checkKeyPress = this.checkKeyPress.bind(this);
    this.filterAccountList = this.filterAccountList.bind(this);
    this.gotoSyncBeneficiary = this.gotoSyncBeneficiary.bind(this);
    this.state = {
      showDelete: false,
      deletePayeeData: '',
      closeModal: true,
      payeeList: '',
      searchData: [],
      searchEnable: false,
      emptysearchList: false,
      showViewPayeePage: false,
      showEditFromPayee: false,
      payeeError: '',
      billerEdit: false,
      addPayeeClicked: false,
    };
  }
  componentWillMount() {
    window.scrollTo(0, 0);
    isNominatedUser = UserManagementStore.isNominatedUser();
    MoveMoneyPayeeStore.addChangeListener(this.onStoreChange);
    MoveMoneyStore.addChangeListener(this.onStoreChange);
    this.setState({
      payeeList: MoveMoneyStore.getAllSavedPayees(),
      payeeError: MoveMoneyStore.getPayeeListError(),
    });
    const backUrl = ManagePaymentsStore.getBackUrl();
    if (backUrl === StringConstant.payeeTaskUrl) {
      ManagePaymentsStore.resetMoveMoneyUrl();
    }
    if (this.props.showEditPayee) {
      this.setState({
        showViewPayeePage: true,
        selectedPayeeData: this.props.editData,
        showEditFromPayee: true,
      });
      if (this.props.editData.hasOwnProperty('biller_id')) {
        this.setState({ billerEdit: true });
      } else {
        this.setState({ billerEdit: false });
      }
    }
  }
  componentDidMount() {
    if (!this.state.showViewPayeePage) {
      sayLandingMessage(this.props.content.managePageheaderTitle);
    }
  }
  componentWillUnmount() {
    MoveMoneyPayeeStore.removeChangeListener(this.onStoreChange);
    MoveMoneyStore.removeChangeListener(this.onStoreChange);
    AnalyticsUtil.analyticAction(
      config.analytics.analytics_experience_view,
      config.analytics.analytics_event_method_appeared,
      'PageLoaded'
    );
  }
  onInputSearchChange() {
    let payeesSuggestion = [];
    if (
      this.state.payeeList.beneficiaries !== undefined &&
      this.state.payeeList.beneficiaries.length > 0
    ) {
      if (this.refs.searchInput.value.length > 2) {
        const searchString = this.refs.searchInput.value.toLowerCase();
        payeesSuggestion = this.state.payeeList.beneficiaries.filter(
          (payee) => {
            return (
              _.includes(
                payee.to_account.name.toString().toLowerCase(),
                searchString
              ) ||
              _.includes(
                payee.display_name.toString().toLowerCase(),
                searchString
              )
            );
          }
        );

        this.setState({
          searchEnable: true,
          searchData: payeesSuggestion,
          emptysearchList: false,
        });
      } else if (this.refs.searchInput.value.length === 0) {
        payeesSuggestion = [];
        this.setState({ emptysearchList: true, searchData: payeesSuggestion });
      }
    }
  }
  onStoreChange() {
    this.setState({
      payeeList: MoveMoneyStore.getAllSavedPayees(),
      payeeError: MoveMoneyStore.getPayeeListError(),
    });
  }
  getTransferYourPayees() {
    const { content } = this.props;
    const iconClass = ['icon-mail'];
    const feedbackContent = (
      <div>
        <p>{content.benSyncCalloutBody}</p>
        <p>{content.benSyncCalloutBody1}</p>
        <p>
          <button
            type="button"
            onClick={this.gotoSyncBeneficiary}
            className="c-btn c-btn--default"
            aria-label="Ok, get started. Bring your payees over"
          >
            {content.benSyncCalloutButton}{' '}
          </button>
        </p>
      </div>
    );
    return (
      <Panel
        iconClass={iconClass}
        panelHeading={[content.benSyncCalloutHeader]}
        panelBody={[feedbackContent]}
      />
    );
  }

  cancelTransactionSearch(e) {
    isSearching = false;
    this.refs.searchInput.value = '';
    this.setState({ emptysearchList: true });
    this.forceUpdate();
    e.preventDefault();
  }

  checkKeyPress(e) {
    if (e.target.tagName === 'LI' || e.target.tagName === 'li') {
      if (e.which === 40 || e.keyCode === 40) {
        if (document.activeElement.nextSibling) {
          document.activeElement.nextSibling.focus();
        }
      } else if (e.which === 38 || e.keyCode === 38) {
        if (document.activeElement.previousSibling) {
          document.activeElement.previousSibling.focus();
        }
      } else if (e.which === 13 || e.keyCode === 13) {
        this.showAddPayeePage(e);
      }
    }
  }

  clearclick(e) {
    isSearching = false;
    this.refs.searchInput.value = '';
    this.setState({ emptysearchList: true });
    this.forceUpdate();
    e.preventDefault();
  }

  closeModal() {
    this.setState({ closeModal: false, showDelete: false });
    let payeesSuggestion = [];
    if (
      this.state.payeeList.beneficiaries !== undefined &&
      this.state.payeeList.beneficiaries.length > 0
    ) {
      if (this.refs.searchInput.value.length > 2) {
        const searchString = this.refs.searchInput.value.toLowerCase();
        payeesSuggestion = this.state.payeeList.beneficiaries.filter(
          (payee) => {
            return (
              _.includes(
                payee.to_account.name.toString().toLowerCase(),
                searchString
              ) ||
              _.includes(
                payee.display_name.toString().toLowerCase(),
                searchString
              )
            );
          }
        );

        this.setState({
          searchEnable: true,
          searchData: payeesSuggestion,
          emptysearchList: false,
        });
      } else if (this.refs.searchInput.value.length === 0) {
        payeesSuggestion = [];
        this.setState({ emptysearchList: true, searchData: payeesSuggestion });
      }
    }
    MoveMoneyPayeeStore.resetStore();
  }

  crossClick() {
    this.setState({ closeModal: false, showDelete: false });
    MoveMoneyPayeeStore.resetStore();
  }

  deleteClick() {
    this.setState({
      closeModal: true,
      showDelete: true,
    });

    const detetePayeeRequestPacket = {
      beneficiary_id: this.state.deletePayeeData.id,
      accountId: this.state.deletePayeeData.account.id,
    };
    MoveMoneyPayeeActionCreator.deletePayee(detetePayeeRequestPacket);
  }
  deleteFromView(deletePayee) {
    window.scroll(0, 0);
    this.setState({
      deletePayeeData: deletePayee,
      showViewPayeePage: false,
      showDelete: true,
      closeModal: true,
    });
  }

  deletePayee(data) {
    this.setState({
      showDelete: true,
      deletePayeeData: data,
      closeModal: true,
    });
  }
  edit(data) {
    if (data.hasOwnProperty('biller_id')) {
      this.setState({ billerEdit: true });
    } else {
      this.setState({ billerEdit: false });
    }
    this.setState({
      showViewPayeePage: true,
      selectedPayeeData: data,
      showEditFromPayee: true,
    });
    this.props.editManagePayeeClick(data);
  }
  filterAccountList() {
    const filterAccount = [];
    _.map(AccountsStore.getAccounts(), (account) => {
      if (
        account.actionsAvailable['/account/payments/uk/default/out'] === true
      ) {
        filterAccount.push(account);
      }
    });
    return filterAccount;
  }
  goToManagePayee() {
    window.scroll(0, 0);
    this.setState({
      searchData: [],
      searchEnable: false,
      addPayeeClicked: false,
      showViewPayeePage: false,
    });
  }
  goToMoveMoneyPage(props) {
    this.props.goToMoveMoneyPage(props);
  }

  gotoSyncBeneficiary() {
    InternetBankingActions.navigateToWebTask(
      StringConstant.WEB_BENEFICIARY_SYNC
    );
  }

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  moveCaretAtEnd(event) {
    event.preventDefault();
    isSearching = true;
    this.forceUpdate();
  }

  navigateToManagePayments(e) {
    e.preventDefault();
    ManagePaymentActionCreator.saveNavigationReference('WEB-MANAGE-PAYEE');
    InternetBankingActions.navigateToWebTask('WEB-MANAGE-PAYMENT');
  }
  // returns payee number in sort code and account number format
  payeeNumber(payee) {
    const accountNumber = payee.to_account.account_number;
    const sortcode = NumberUtils.formatSortCode(payee.to_account.sort_code);
    return `${sortcode} | ${accountNumber}`;
  }

  retryServices() {
    MoveMoneyActionCreator.getFromPayeeList();
  }
  showAddPayeePage() {
    this.setState({ addPayeeClicked: true });
  }

  showManagePayeePage() {
    window.scroll(0, 0);
    if (this.props.showEditPayee) {
      this.props.goToMoveMoneyPage();
    } else this.setState({ showViewPayeePage: false, billerEdit: false });
  }

  showViewPayeePage(data) {
    if (data.hasOwnProperty('biller_id')) {
      this.setState({ billerEdit: true });
    } else {
      this.setState({ billerEdit: false });
    }
    this.setState({
      showViewPayeePage: true,
      selectedPayeeData: data,
      showEditFromPayee: false,
    });
    this.props.editManagePayeeClick(data);
  }

  renderManagePayee() {
    const classNN = isSearching ? 'focused' : '';
    let bodyContent;
    let footerButtons;
    let reviewModal;
    let modalHeading;
    let size;

    const editPayeeResponse = MoveMoneyPayeeStore.editPayeeResponse();

    // Loader is shown when the store asks to wait and does that when it is making a service call so that until it gets the response the loader should be shown.
    if (MoveMoneyPayeeStore.getDeletePayeeLoader()) {
      bodyContent = <LoaderComponent type="small" />;
      reviewModal = 'c-modal';
      modalHeading = '';
      footerButtons = '';
      size = 'medium';
    } else if (editPayeeResponse.code === 422) {
      bodyContent = (
        <div>
          <div className="modal_content error-popup">
            <p>
              <strong>
                {editPayeeResponse?.error?.message ||
                  this.props.content.duplicatePayeeErrrmsg}
              </strong>
            </p>
          </div>
        </div>
      );
      reviewModal = 'c-modal';
      modalHeading = '';
      footerButtons = (
        <button
          className="c-btn c-btn--default c-modal__button"
          onClick={this.crossClick}
        >
          {this.props.content.ok}
        </button>
      );
      size = 'medium';
    } else if (this.state.deletePayeeData !== '') {
      let calloutComponentMessage = <div />;
      if (!AccountsStore.isCreditCardUser()) {
        if (this.state.deletePayeeData.hasOwnProperty('biller_id')) {
          calloutComponentMessage = <div />;
        } else {
          calloutComponentMessage = (
            <div className="callout">
              <div className="callout__wrapper">
                <p>
                  <strong>{this.props.content.deletePayeePopUp1}</strong>
                </p>
                <p>
                  {this.props.content.deletePayeePopUp2}
                  <a
                    href="javascript:void(0)"
                    onClick={this.navigateToManagePayments}
                  >
                    {this.props.content.deletePayeePopUp3}
                  </a>
                  .
                </p>
              </div>
            </div>
          );
        }
      }
      // When there is no confirmation from service to delete the payee.
      if (!this.props.deletePayee) {
        bodyContent = (
          <div className="delete-payee">
            {calloutComponentMessage}
            <dl className="c-definitions delete-payee--list">
              <dt className="c-definitions__key">Name</dt>
              <dd className="c-definitions__value">
                {this.state.deletePayeeData.to_account.name}
              </dd>

              <dt className="c-definitions__key">Nickname</dt>
              {this.state.deletePayeeData.hasOwnProperty('display_name') &&
              this.state.deletePayeeData.display_name !== '' ? (
                <dd className="c-definitions__value">
                  {this.state.deletePayeeData.display_name}
                </dd>
              ) : (
                <dd className="c-definitions__value">-</dd>
              )}
              <dt className="c-definitions__key">Sort code</dt>
              <dd className="c-definitions__value">
                {NumberUtils.formatSortCode(
                  this.state.deletePayeeData.to_account.sort_code
                )}
              </dd>

              <dt className="c-definitions__key">Account number</dt>
              <dd className="c-definitions__value">
                {this.state.deletePayeeData.to_account.account_number}
              </dd>

              <dt className="c-definitions__key">Reference</dt>
              <dd className="c-definitions__value">
                {this.state.deletePayeeData.reference}
              </dd>
            </dl>
          </div>
        );
        footerButtons = (
          <div className="delete-payee__options">
            <button
              type="button"
              className="c-btn c-btn--secondary"
              onClick={this.closeModal}
            >
              Close
            </button>
            <button
              type="button"
              className="c-btn c-btn--default"
              onClick={this.deleteClick}
              id="delete"
              role="button"
              aria-haspopup="true"
              aria-labelledby={`delete ${this.state.deletePayeeData.id}`}
            >
              {this.props.content.deletePopupBtn}
            </button>
          </div>
        );
        reviewModal = 'c-modal';
        modalHeading = this.props.content.deletePopupHeading;
        size = 'large';
      } else {
        // Body Content when delete payee is successful.

        bodyContent = (
          <div className="delete-payee--success">
            <SvgIcon id="icon-success" width="128px" height="128px" />

            {this.state.deletePayeeData.hasOwnProperty('display_name') &&
            this.state.deletePayeeData.display_name !== '' ? (
              <p className="<delete-payee--success__msg">
                <span id={this.state.deletePayeeData.id}>
                  {this.state.deletePayeeData.display_name}
                </span>
                {this.props.content.payeePoupDeleted}
              </p>
            ) : (
              <p className="<delete-payee--success__msg">
                <span id={this.state.deletePayeeData.id}>
                  {this.state.deletePayeeData.to_account.name}
                </span>
                {this.props.content.payeePoupDeleted}
              </p>
            )}
            <button
              type="button"
              className="c-btn c-btn--default"
              onClick={this.closeModal}
            >
              OK
            </button>
          </div>
        );
        footerButtons = '';
        reviewModal = 'c-modal c-modal--center';
        modalHeading = '';
        size = 'medium';
      }
    }
    let headerContent = 'Payees';
    let bodyContent1 = 'We were unable to load your payees at this time.';
    let bodyContent2 = '';

    const shouldShowTransferPayees = this.props.brandId !== 'VM';
    const mainColumnWidth = shouldShowTransferPayees
      ? 'col-md1-16 col-lg1-18'
      : 'col-md1-24';
    const asideColumnWidth = shouldShowTransferPayees
      ? 'col-md1-8 col-lg1-6'
      : '';
    const { session, envConfig, user } = this.props;
    return (
      <div>
        {this.state.payeeError ? (
          <NonBCustomerError
            headerContent={headerContent}
            buttonName2="Retry"
            bodyContent1={bodyContent1}
            bodyContent2={bodyContent2}
            handleButtonClick2={this.retryServices}
            headerFlag
            hideButton1
            componentName
            page={false}
          />
        ) : (
          <div>
            {this.state.addPayeeClicked ? (
              <AddPayeeOrCompanyMainPage
                content={this.props.content}
                goToMoveMoneyPage={this.goToMoveMoneyPage}
                goBackToMoveMoney={this.goToManagePayee}
                goToManagePayees={this.goToManagePayee}
                filterAccountList={this.filterAccountList}
                isSMEUser={this.props.isSMEUser}
                isFromManagePayee
                session={session}
                envConfig={envConfig}
                user={user}
              />
            ) : (
              <div
                className="container manage-payee"
                role="main"
                id="site-main"
                tabIndex="-1"
              >
                <StepHeader
                  showheaderCrumbs="true"
                  onClick={this.props.backClick}
                  headerCrumbsMessage="Back"
                  headerTitle={this.props.content.managePageheaderTitle}
                />
                <div className="row">
                  <div
                    className={`${mainColumnWidth} account-card-list accaccount-card-list--to`}
                  >
                    <ul
                      role="application"
                      className="account-card-list__payee-list"
                    >
                      <div className="account-card-list__payee-list__header payee-subheader">
                        <h3 className="list-type">Payees</h3>
                        {this.state.payeeList.beneficiaries !== undefined &&
                        this.state.payeeList.beneficiaries.length > 0 ? (
                          <div className="search-payee">
                            <form action="." className="autofillSearch">
                              <input
                                id="timelineSearch"
                                type="search"
                                placeholder="Search"
                                ref="searchInput"
                                onKeyPress={this.handleKeyPress}
                                onFocus={this.moveCaretAtEnd}
                                onChange={this.onInputSearchChange}
                                className={`type--jura ${classNN}`}
                                autoComplete="off"
                                minLength={2}
                                aria-label="Search Payee"
                              />

                              {this.refs.searchInput &&
                              this.refs.searchInput.value.length > 0 ? (
                                <a
                                  href="javascript:;"
                                  onClick={this.clearclick}
                                  aria-label="Clear Search"
                                  className="searchClear icon icon-clear"
                                />
                              ) : (
                                ''
                              )}
                              <a
                                href="javascript:void(0)"
                                className="search-cancel opt-green"
                                aria-label="Cancel Search"
                                onClick={this.cancelTransactionSearch}
                              >
                                Cancel
                              </a>
                            </form>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                      {isNominatedUser ? (
                        ''
                      ) : (
                        <button
                          className="account-card account-card--new-payee account-card--noborder"
                          onClick={this.showAddPayeePage}
                          onKeyDown={this.checkKeyPress}
                        >
                          <div
                            className="account-card--new-payee__content"
                            role="presentation"
                          >
                            <span>
                              <svg
                                width="32px"
                                height="32px"
                                viewBox="0 0 48 48"
                              >
                                <g
                                  stroke="none"
                                  strokeWidth="1"
                                  fill="none"
                                  fill-rule="evenodd"
                                >
                                  <g
                                    transform="translate(-1652.000000, -210.000000)"
                                    fill="#000"
                                  >
                                    <g transform="translate(167.000000, 200.000000)">
                                      <path
                                        d="M1508.99962,55.0007031 C1497.40144,55.0007031 1488.00005,45.5993062 1488.00005,34.000375 C1488.00005,22.4014438 1497.40144,13.0000469 1508.99962,13.0000469 C1520.59781,13.0000469 1529.99995,22.4014438 1529.99995,34.000375 C1529.99995,45.5993062 1520.59781,55.0007031 1508.99962,55.0007031 M1508.99962,10 C1495.74467,10 1485,20.7446679 1485,34.000375 C1485,47.2560821 1495.74467,58.00075 1508.99962,58.00075 C1522.25458,58.00075 1533,47.2560821 1533,34.000375 C1533,20.7446679 1522.25458,10 1508.99962,10 M1510.4644,32.5356021 L1510.4644,24.2209722 C1510.46515,23.4124596 1509.80889,22.7561993 1508.99962,22.7561993 C1508.19111,22.7561993 1507.53485,23.4124596 1507.53485,24.2209722 L1507.53485,32.5356021 L1499.22022,32.5356021 C1498.41171,32.5356021 1497.75545,33.1903623 1497.75545,34.000375 C1497.75545,34.8088876 1498.41171,35.4651479 1499.22022,35.4651479 L1507.53485,35.4651479 L1507.53485,43.7797778 C1507.53485,44.5882904 1508.19111,45.2445507 1508.99962,45.2445507 C1509.80889,45.2445507 1510.4644,44.5882904 1510.4644,43.7797778 L1510.4644,35.4651479 L1518.77903,35.4651479 C1519.58829,35.4651479 1520.2438,34.8088876 1520.2438,34.000375 C1520.2438,33.1903623 1519.58829,32.5356021 1518.77903,32.5356021 L1510.4644,32.5356021 Z"
                                        id="icon-add"
                                      />
                                    </g>
                                  </g>
                                </g>
                              </svg>
                            </span>
                            {this.props.content.payNew}
                          </div>
                        </button>
                      )}
                      {this.state.searchEnable === false ||
                      this.state.emptysearchList === true
                        ? this.state.payeeList.beneficiaries
                          ? _.map(
                              this.state.payeeList.beneficiaries,
                              (payee) => {
                                return (
                                  <ManagePayeeCard
                                    key={payee.id}
                                    payee={payee}
                                    delete={this.deletePayee}
                                    onClick={this.showViewPayeePage}
                                    goToMoveMoneyPage={this.goToMoveMoneyPage}
                                    edit={this.edit}
                                  />
                                );
                              }
                            )
                          : ''
                        : this.state.searchData.length >= 1 &&
                          this.state.searchEnable === true
                        ? _.map(this.state.searchData, (payee, index) => {
                            return (
                              <ManagePayeeCard
                                payee={payee}
                                delete={this.deletePayee}
                                edit={this.edit}
                                onClick={this.showViewPayeePage}
                                goToMoveMoneyPage={this.goToMoveMoneyPage}
                              />
                            );
                          })
                        : 'No results'}
                    </ul>
                  </div>
                  {shouldShowTransferPayees && (
                    <div className={asideColumnWidth}>
                      <aside id="site-sidebar" tabIndex="-1">
                        {this.getTransferYourPayees()}
                      </aside>
                    </div>
                  )}
                </div>
              </div>
            )}

            {this.state.showDelete ? (
              <PatternLibModalComponent
                show={this.state.closeModal}
                customClass={reviewModal}
                onHide={this.crossClick}
                bsSize={size}
                modalHeading={modalHeading}
                modalBody={bodyContent}
                modalFooter={footerButtons}
                modalInContainer={false}
                closeButton
                backdrop="static"
              />
            ) : (
              ''
            )}
          </div>
        )}
      </div>
    );
  }
  renderPayeeViewPage() {
    const { isSMEUser, content, session, envConfig, user } = this.props;
    return (
      <ViewPayeePage
        payeeData={this.state.selectedPayeeData}
        content={content}
        goBack={this.showManagePayeePage}
        deleteFromView={this.deleteFromView}
        showEditFromPayee={this.state.showEditFromPayee}
        billerEdit={this.state.billerEdit}
        goToMoveMoneyPage={this.goToMoveMoneyPage}
        goToManagePayee={this.goToManagePayee}
        isSMEUser={isSMEUser}
        session={session}
        envConfig={envConfig}
        user={user}
      />
    );
  }

  render() {
    return (
      <BioCatchContext context={MANAGE_PAYEE_CONTEXT}>
        <div className="bow">
          {/* <span id="accessH1ID" ref="accessH1ID" tabIndex="0" className="u-visually-hidden off-screen"> You are on {this.props.content.managePageheaderTitle}</span> */}
          {this.state.showViewPayeePage
            ? this.renderPayeeViewPage()
            : this.renderManagePayee()}
        </div>
      </BioCatchContext>
    );
  }
}
ManagePayeePage.propTypes = {
  brandId: PropTypes.string.isRequired,
  content: PropTypes.object,
  showEditPayee: PropTypes.bool,
  editData: PropTypes.object,
  editManagePayeeClick: PropTypes.func,
  deletePayee: PropTypes.bool,
  goToMoveMoneyPage: PropTypes.func,
  payeeData: PropTypes.object,
  backClick: PropTypes.func,
  isSMEUser: PropTypes.bool.isRequired,
};
ManagePayeePage.defaultProps = {
  content: {},
  editData: {},
  showEditPayee: false,
  deletePayee: false,
  payeeData: [],
};

export default ManagePayeePage;
